import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { ClienteAtendimentoFiltrosCriteria, ClienteFiltrosCriteria } from "@workflow/types";

import { clienteService } from "@/services/api/cliente.service";

const MINUTE = 1000 * 60;
const LIST_STALE = 30 * 1000;
const FILTROS_STALE = 30 * MINUTE;

/**
 * Query keys do domínio "clientes". `list` mantém a key legada `['clientes-matriz-list']`
 * — a mesma que `useClienteActions` invalida e que `useClientes` já consome —, então a
 * invalidação existente das mutations continua alcançando esta lista.
 */
export const clientesKeys = {
  list: ["clientes-matriz-list"] as const,
  resumo: ["clientes-resumo-totais"] as const,
  filtros: ["clientes-filtros"] as const,
  ativos: ["clientes-ativos"] as const,
  atendimentoList: ["clientes-atendimento-list"] as const,
  atendimentoFiltros: ["clientes-atendimento-filtros"] as const,
};

export const clientesQueries = {
  list: (criteria: ClienteFiltrosCriteria) =>
    queryOptions({
      queryKey: [...clientesKeys.list, criteria],
      queryFn: () => clienteService.listClientes(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  /** Todos os clientes ativos, para seletores (combobox) — lista pequena, muda pouco. */
  ativos: () =>
    queryOptions({
      queryKey: clientesKeys.ativos,
      queryFn: () => clienteService.getAllActiveClientes(),
      staleTime: 5 * MINUTE,
    }),

  filtros: () =>
    queryOptions({
      queryKey: clientesKeys.filtros,
      queryFn: () => clienteService.getFiltrosCliente(),
      staleTime: FILTROS_STALE,
    }),

  atendimentoList: (criteria: ClienteAtendimentoFiltrosCriteria) =>
    queryOptions({
      queryKey: [...clientesKeys.atendimentoList, criteria],
      queryFn: () => clienteService.listClientesAtendimento(criteria),
      placeholderData: keepPreviousData,
      staleTime: LIST_STALE,
    }),

  atendimentoFiltros: () =>
    queryOptions({
      queryKey: clientesKeys.atendimentoFiltros,
      queryFn: () => clienteService.getFiltrosClienteAtendimento(),
      staleTime: FILTROS_STALE,
    }),
};
